import './StatsDialog.less';

import React, { FC } from 'react';
import i18n from '@i18n';
import { getConfigProperty } from '@/common/oldMobile';

const StatsDialog: FC<{ statisticsId: string; isTournament?: boolean }> = ({ statisticsId, isTournament }) => {
    const lang = getConfigProperty('lang');
    const sportradarUrl = getConfigProperty('sportradarUrl');
    const stats = isTournament ? 'tournament' : 'match';
    const src = `${sportradarUrl}${lang}/${stats}/${statisticsId}`;
    return statisticsId ? (
        <div className="stats-dialog">
            <div className="uppercase flex-center c-white text-extra-bold fs-18 py-20">{i18n('nui.dialog.stats')}</div>
            <iframe title="Match statistics" src={src} height="100%" width="100%" frameBorder="0" allowFullScreen />
        </div>
    ) : null;
};

export default StatsDialog;
